import { AfterViewInit, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { selectAllBatchs } from '../../../features/batch/batch.selectors';
import { Store } from '@ngrx/store';
import { FormControl } from '@angular/forms';
import { selectUser } from '../../../features/user/user.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { User } from '../../../models/user';
import { map } from 'rxjs/operators';
import {
  selectAdvancedFeaturesAvailable
} from '../../../features/site/site.selectors';


@Component({
    selector: 'batch-diff-representation-selector-dialog',
    templateUrl: './batch-diff-representation-selector.dialog.html',
    styleUrls: ['../dialog.scss', './batch-diff-representation-selector.dialog.scss'],
    standalone: false
})
export class BatchDiffRepresentationSelectorDialog implements AfterViewInit {
  icon: string | undefined;
  title: string = '';
  subtitle: string | undefined;
  message: string = '';
  batchComparedId: string | undefined;
  batchReferenceId: string | undefined;

  batchComparedControl = new FormControl('');
  batchReferenceControl = new FormControl('');
  private user: User | null | undefined;

  readonly advancedFeaturesAvailable$ = this.store.select(selectAdvancedFeaturesAvailable);
  readonly batchs$ = this.store.select(selectAllBatchs);
  readonly dateFormat$ = this.store.select(selectUser).pipe(
    map(user =>
      user?.languageCode === 'fr'
        ? 'dd/MM/yyyy'
        : 'MM/dd/yyyy'
    )
  );

  constructor(private store: Store, public dialogRef: MatDialogRef<BatchDiffRepresentationSelectorDialog>) {
    this.initHandleUser();
  }

  private initHandleUser(): void {
    this.store.select(selectUser)
      .pipe(takeUntilDestroyed())
      .subscribe((user: User | undefined) => {
        if (user) {
          this.user = user;
        }
      });
  }

  ngAfterViewInit(): void {
    this.batchComparedControl.setValue(this.batchComparedId || '');
    this.batchReferenceControl.setValue(this.batchReferenceId || '');
    this.batchComparedControl.disable();
    this.batchReferenceControl.disable();
  }
}
